import slReducer from "./slReducer";

export default slReducer;
export * from "./slReducer";
